import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import FnrButton from "UI/FnrButton3";

import unoPiggyBank from "./uno-piggy-bank.png";

FundItMemberSplash.propTypes = {
  networkIsSignedUpForPayments: PropTypes.bool,
  isSuperAdmin: PropTypes.bool,
  isGroupAdminForAnyGroup: PropTypes.bool,
  networkName: PropTypes.string,
  hideFundItSplashToRegularUsers: PropTypes.bool,
};

export default function FundItMemberSplash({
  networkIsSignedUpForPayments,
  isSuperAdmin,
  isGroupAdminForAnyGroup,
  networkName,
  hideFundItSplashToRegularUsers,
}) {
  if (
    hideFundItSplashToRegularUsers ||
    !networkIsSignedUpForPayments ||
    isSuperAdmin ||
    isGroupAdminForAnyGroup
  ) {
    return null;
  }

  const composeTitle = () => {
    return networkName ? `Donate to ${networkName}` : `Make a Donation`;
  };

  return (
    <Wrapper>
      <Title>
        <img src={unoPiggyBank} alt="" />
        {composeTitle()}
      </Title>
      <Body>
        Make a one-time gift or set up a recurring donation. Thank you for your
        generosity!
      </Body>
      <ButtonWrapper>
        <a href="/give" target="_blank" rel="noreferrer">
          <FnrButton color="yellow">
            <BtnIcon className="fas fa-lock" /> Donate Securely
          </FnrButton>
        </a>
      </ButtonWrapper>
      <Help>
        Need help?{" "}
        <a
          href="https://flocknote.com/contact/"
          target="_blank"
          rel="noreferrer"
        >
          Click here
        </a>
        .
      </Help>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background-color: #6ec1e4;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 40px; // needed to get past flame image if network has WOF engage splash showing
  box-shadow: rgba(0, 0, 0, 0.2) 1px 2px 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 400;
`;

const Title = styled.h2`
  color: white;
  font-size: 26px;
  font-weight: 600;
  font-style: italic;
  text-align: center;

  img {
    height: 26px;
    margin-right: 10px;
  }

  @media (max-width: 550px) {
    font-size: 21px;
  }
`;

const Body = styled.div`
  margin-top: 16px;
  font-size: 16px;
  text-align: center;
  max-width: 240px;

  @media (max-width: 550px) {
    font-size: 15px;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 16px;

  a,
  a:hover {
    text-decoration: none;
  }
`;

const BtnIcon = styled.span`
  color: white;
  margin-right: 6px;
`;

const Help = styled.div`
  font-size: 12px;
  margin-top: 10px;

  a,
  a:visited {
    color: inherit;
  }
`;
